import { useState } from "react";

export const CoverImage = ({ src, alt }: { src: string; alt: string }) => {
	const [source, setSource] = useState(src);

	return (
		<img
			src={source}
			alt={alt}
			onError={() => setSource("/img/saved-kid.webp")}
			className="w-full h-[148px] object-cover"
		/>
	);
};
